module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-Semibold.cabb7ea.otf";